// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  background-color: #1a1a2e;
  color: white;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #4ecca3;
  text-decoration: none;
  transition: color 0.3s ease;
}

.nav-brand:hover {
  color: #3db88a;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

.nav-link:hover {
  color: #4ecca3;
  background-color: rgba(78, 204, 163, 0.1);
}

.nav-link-admin {
  background-color: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.nav-link-admin:hover {
  background-color: rgba(255, 193, 7, 0.3);
  color: #ffca28;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-left: 1rem;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-user-name {
  font-size: 0.9rem;
  color: #ccc;
}

.nav-button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.nav-button-primary {
  background-color: #4ecca3;
  color: #1a1a2e;
}

.nav-button-primary:hover {
  background-color: #3db88a;
  transform: translateY(-1px);
}

.nav-button-secondary {
  background-color: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.nav-button-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
  }

  .nav-user {
    flex-direction: column;
    padding-left: 0;
    border-left: none;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,8CAA8C;EAChD;AACF","sourcesContent":[".navigation {\n  background-color: #1a1a2e;\n  color: white;\n  padding: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.nav-brand {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #4ecca3;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.nav-brand:hover {\n  color: #3db88a;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.nav-link {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  transition: color 0.3s ease;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n}\n\n.nav-link:hover {\n  color: #4ecca3;\n  background-color: rgba(78, 204, 163, 0.1);\n}\n\n.nav-link-admin {\n  background-color: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n}\n\n.nav-link-admin:hover {\n  background-color: rgba(255, 193, 7, 0.3);\n  color: #ffca28;\n}\n\n.nav-user {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding-left: 1rem;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.nav-user-name {\n  font-size: 0.9rem;\n  color: #ccc;\n}\n\n.nav-button {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.nav-button-primary {\n  background-color: #4ecca3;\n  color: #1a1a2e;\n}\n\n.nav-button-primary:hover {\n  background-color: #3db88a;\n  transform: translateY(-1px);\n}\n\n.nav-button-secondary {\n  background-color: transparent;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.nav-button-secondary:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n@media (max-width: 768px) {\n  .nav-container {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .nav-links {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.5rem;\n  }\n\n  .nav-user {\n    flex-direction: column;\n    padding-left: 0;\n    border-left: none;\n    padding-top: 0.5rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
